var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74999 11.7501L1.37524 13.1249C1.16674 13.3334 0.926994 13.3829 0.655994 13.2734C0.385494 13.1639 0.250244 12.9634 0.250244 12.6719V3.06288C0.250244 2.69837 0.377744 2.38838 0.632744 2.13288C0.888244 1.87788 1.19824 1.75038 1.56274 1.75038H7.78099C7.72899 1.96888 7.70299 2.18762 7.70299 2.40663C7.70299 2.62512 7.72899 2.84387 7.78099 3.06288H1.56274V10.4376H11.4372V5.51613C11.6767 5.46362 11.9085 5.39062 12.1325 5.29712C12.3565 5.20312 12.5622 5.08337 12.7497 4.93787V10.4376C12.7497 10.8021 12.6222 11.1121 12.3672 11.3676C12.1117 11.6226 11.8017 11.7501 11.4372 11.7501H2.74999ZM10.8747 4.42188C10.3542 4.42188 9.91149 4.23962 9.54649 3.87512C9.18199 3.51062 8.99974 3.06787 8.99974 2.54688C8.99974 2.02638 9.18199 1.58362 9.54649 1.21862C9.91149 0.854125 10.3542 0.671875 10.8747 0.671875C11.3957 0.671875 11.8385 0.854125 12.203 1.21862C12.5675 1.58362 12.7497 2.02638 12.7497 2.54688C12.7497 3.06787 12.5675 3.51062 12.203 3.87512C11.8385 4.23962 11.3957 4.42188 10.8747 4.42188Z",
    fill: "#51606F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkChat);
export default __webpack_public_path__ + "static/media/markChat.f789834855e52c300c0f55f885590bc3.svg";
export { ForwardRef as ReactComponent };